import React, { Component } from "react";

class DropZone extends Component {
    state = {
        isDraggedOver: false
    };
    onDragOver = (e) => {
        e.preventDefault();
        let elDragData = this.props.elDragData;
        this.props.setDragZoneStatus(true);
        this.setState(
            {
                dataSetOnDragOver: elDragData,
                isDraggedOver: true
            },
            () => {
                setTimeout(() => {
                    this.props.addGhostElementOnDragOver();
                    
                }, 100);
            }
        );
    };
    onDragLeave = (e) => {
        this.setState({ isDraggedOver: false }, () => {
            setTimeout(() => {
                
                this.props.removeGhostElementOnDragLeave();
            }, 100);
        });
    };
    render() {
        return (
            <div
                onDragOver={(e) =>
                    !this.state.isDraggedOver && this.onDragOver(e)
                }
                onDragLeave={(e) =>
                    this.state.isDraggedOver && this.onDragLeave(e)
                }
                style={this.props.style}
            ></div>
        );
    }
}

export { DropZone };
